import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { BlockIcon } from '@wordpress/block-editor';
import { gallery as icon } from '@wordpress/icons';
export const sharedIcon = createElement(BlockIcon, {
  icon: icon
});
//# sourceMappingURL=shared-icon.js.map